import { toggleBannerStatus } from '../utils';
import { BROADCAST_SYNC_BANNERS_STATUS } from 'actions/Types';

export default bannerId => {
  return (dispatch, getState) => {
    const { banners } = getState();
    const updatedBanners = toggleBannerStatus(bannerId, banners);
    const action = {
      type: BROADCAST_SYNC_BANNERS_STATUS,
      payload: {
        banners: updatedBanners
      }
    };
    dispatch(action);
  };
};
